import { buttonInputStyle } from './shared-styles-from-theme-fluent';

export const gridPopUpEditorStyle = ({ palette }) => ({
  '[role="dialog"].popup-editor': {
    padding: '24px 16px',
    zIndex: '10',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',

    '& .form-validation-container[data-property="Name"]': {
      width: '200px',
    },
  },
  '[role="dialog"].popup-editor .form-inline .form-group': {
    display: 'block !important',
  },
  '.form-group ~ .form-group': {
    marginTop: 16,
  },
  '.popup-editor .btn ~ .btn': {
    marginLeft: 8,
  },
  '.grid-popupeditor': {
    ...buttonInputStyle({ palette }),
    position: 'absolute',
    zIndex: '10',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
    minHeight: 50,
    padding: '24px 16px',
    width: 'fit-content',
    display: 'table',
  },
  '.grid-popupeditor.inline-budget-editor-popup': {
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingLeft: '24px',
    paddingRight: '16px',
  },
  '.grid-popupeditor .btn ~ .btn': {
    marginLeft: 8,
  },
  '.grid-popupeditor label': {
    display: 'inline-block',
  },
  '.popup-editor, .grid-popupeditor': {
    '& ul.help-block.error, ul[role="alert"], .grid-error-list': {
      listStyle: 'none',
      paddingLeft: 0,
      margin: 0,
      '& > li': {
        margin: '5px 0px 0px 0px',
      },
      '& > li:empty': {
        margin: 0,
      },
    },
  },
  // body has default height of 0 as components in it has position: absolute
  // give it a height of view port so that grid inline-edit popup can be positioned correctly
  body: {
    height: '100vh',
  },
  '.popup-editor .error, .grid-popupeditor .error, .grid-popupeditor .font-error, .k-widget .error, .popup-editor .is-error': {
    color: '#A80000',
    fontSize: 12,
  },
});
